module.exports = __webpack_public_path__ + "static/media/change direction icon.168ae261.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/route-finder/change direction icon.svg
// module id = 837
// module chunks = 0